import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../../context";

export const useReservationRequiredPlanSelectForReservation = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { requiredPlanSelectForReservation } = viewModel;

	const isEdited = requiredPlanSelectForReservation.isEdited;
	const hasError = Boolean(requiredPlanSelectForReservation.error);

	const onSetRequiredPlanSelectForReservation = useCallback(
		(input: boolean) => {
			onSetViewModel([
				{
					key: "requiredPlanSelectForReservation",
					value: {
						...requiredPlanSelectForReservation,
						value: input,
					},
				},
			]);
		},
		[onSetViewModel, requiredPlanSelectForReservation],
	);

	return {
		isEdited,
		hasError,

		requiredPlanSelectForReservation,
		onSetRequiredPlanSelectForReservation,
	};
};
